import './testOrderResultTable.scss';

import React, {useCallback, useState} from 'react';
import {ITableColumn} from "../../../../../shared/models/table.model";
import {CommonService} from "../../../../../shared/services";
import {ISample} from "../../../../../shared/models/sample.model";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {APIConfig, ImageConfig} from "../../../../../constants";
import TableWrapperV2Component
    from "../../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import {VisibilityRounded} from "@mui/icons-material";
import {IAPIResponseType} from "../../../../../shared/models/api.model";
import DialogComponent from "../../../../../shared/components/dialog/dialogComponent";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import commonService from "../../../../../shared/services/common.service";
import LottieFileGenarationComponent
    from "../../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import StatusCardComponent from "../../../../../shared/components/status-card/statusCardComponent";

interface TestOrderResultTableComponentProps {
    filterData: any;
}


const TestOrderResultTableComponent = (props: TestOrderResultTableComponentProps) => {

    const {filterData} = props;

    const [isResultLogDialogOpen, setIsResultLogDialogOpen] = useState<boolean>(false);
    const [resultLogs, setResultLogs] = useState<any>([]);
    const [isResultLogLoading, setIsResultLogLoading] = useState<boolean>(false);
    const [isResultLogLoadingFailed, setIsResultLogLoadingFailed] = useState<boolean>(false);
    const [isResultLogLoaded, setIsResultLogLoaded] = useState<boolean>(false);


    const columns: ITableColumn[] = [
        {id: 'barcode', label: 'Accession ID', isDefaultColumn: true, fixed: 'left',width:"150"},
        {
            id: 'name', label: 'Test Name',
            isDefaultColumn: true,
            content: (item: ISample) => (
                <>
                    {
                        item?.testDetails ?
                            <>
                                {item?.testDetails.name || '-'}
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'result', label: 'Result Date',
            isDefaultColumn: true,
            content: (item: ISample) => (
                <>
                    {
                        item.pdfGeneratedDate ?
                            <>
                                {commonService.formatDate(item?.pdfGeneratedDate)}
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'resultTime', label: 'Result Time',
            isDefaultColumn: true,
            align: 'center',
            content: (item: ISample) => (
                <>
                    {
                        item?.pdfGeneratedDate ?
                            <>
                                {commonService.formatDate(item?.pdfGeneratedDate)}
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'pdf', label: 'Result', isDefaultColumn: true,
            align: 'center',
            content: (item: ISample) => (
                <>
                    {
                        item?.pdfDetails?.url ?
                                <a href={item?.pdfDetails?.url}
                                   target="_blank" rel="noreferrer"
                                >
                                <PictureAsPdfIcon/>
                                </a> : '-'
                    }
                </>
            )
        },
        {
            id: 'viewLog',
            label: '',
            isDefaultColumn: true,
            hideInColumnPreferences: true,
            fixed: "right",
            align: "center",
            content: (sample: any) => (
                <>
                    <ButtonComponent
                        type="button"
                        color={"secondary"}
                        variant={"outlined"}
                        startIcon={<VisibilityRounded/>}
                        size={"small"}
                        disabled={!sample.pdfGeneratedDate}
                        handleClick={() => {
                            handleOpenResultLogDialog(sample);
                        }}
                    >
                        View Log
                    </ButtonComponent>
                </>

            )
        }

    ];

    const getResultLogs = useCallback((sampleId: any) => {
        const payload = {}
        setIsResultLogLoaded(false);
        setIsResultLogLoading(true);
        setIsResultLogLoadingFailed(false);
        CommonService._result.getResultLogs(sampleId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    setIsResultLogLoaded(true);
                    setIsResultLogLoading(false);
                    setIsResultLogLoadingFailed(false);
                    setResultLogs(response?.data?.docs);
                }
            })
            .catch((error: any) => {
                setIsResultLogLoaded(false);
                setIsResultLogLoading(false);
                setIsResultLogLoadingFailed(true);
            })
    }, []);

    const handleOpenResultLogDialog = useCallback((sample: any) => {
        getResultLogs(sample?.id);
        setIsResultLogDialogOpen(true);

    }, [getResultLogs]);

    return (
        <div className="table-list-container test-order-result-table t-table-inside-details">
            <TableWrapperV2Component
                url={APIConfig.SAMPLES_LIST.URL}
                method={APIConfig.SAMPLES_LIST.METHOD}
                isPaginated={true}
                columns={columns}
                moduleName={'test-order-result-table'}
                extraPayload={filterData}
                isHoverable={true}
                isStickyHeader={true}
                isColumnFilterVisible={false}
            />
            <DialogComponent open={isResultLogDialogOpen}
                // onClose={closeUploadXlsDialogComponent}
                             isShowCancel={false}
                             maxWidth={"md"}>
                <div className={'result-log-dialog-wrapper'}>
                    <div className="result-log-dialog-header">
                        Result Log
                    </div>
                    {
                        isResultLogLoading && <div className="h-v-center">
                            <LottieFileGenarationComponent
                                loop={true}
                                autoplay={true}
                                animationData={ImageConfig.LoadingLottieFile}/>
                        </div>
                    }
                    {
                        isResultLogLoadingFailed && <>
                            <StatusCardComponent title={"TestOrder details failed to load"}/>
                        </>
                    }
                    {
                        isResultLogLoaded && <>
                            <div className="result-log-dialog-body">
                                {
                                    resultLogs?.map((log: any, index: number) => {
                                        return (
                                            <div className="result-log-item" key={index}>
                                                <div className={'result-log-pdf-icon'}>
                                                    <ImageConfig.PDFIcon width={40} height={45}/>
                                                </div>
                                                <div className="result-log-item-header">
                                                    <div className="result-log-item-header-title">
                                                        {commonService.capitalizeFirstLetterOfEachWord(log?.sampleDetails?.panelDetails?.name)}
                                                    </div>
                                                    <div className="result-log-item-header-details">
                                                        <DetailsDataKeyValueComponent title={'Result Date:'}
                                                                                      isHorizontal={true}>
                                                            {commonService.formatDate(log?.createdAt)}
                                                        </DetailsDataKeyValueComponent>
                                                        <DetailsDataKeyValueComponent title={'Result Time:'}
                                                                                      isHorizontal={true}>
                                                            {commonService.formatTime(log?.createdAt)}
                                                        </DetailsDataKeyValueComponent>
                                                        <DetailsDataKeyValueComponent title={'Added by:'}
                                                                                      isHorizontal={true}>
                                                            {log?.loginUserDetails?.firstName + (log?.loginUserDetails?.middleName ? log?.logInUserDetails?.middleName : '') + log?.loginUserDetails?.lastName}
                                                        </DetailsDataKeyValueComponent>
                                                    </div>
                                                </div>
                                                <div className="result-log-item-body">
                                                    <a href={log?.pdfDetails?.url}
                                                       target="_blank" rel="noreferrer"
                                                    >
                                                        <ButtonComponent
                                                            size={"small"}
                                                            color={"primary"}
                                                            variant={"outlined"}
                                                            type={"button"}
                                                            startIcon={<VisibilityRounded/>}
                                                        >
                                                            View Result
                                                        </ButtonComponent>
                                                    </a>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                    <div className={'result-log-dialog-close-button'}>
                        <ButtonComponent
                            variant={"outlined"}
                            color={"secondary"}
                            type={"button"}
                            handleClick={() => {
                                setIsResultLogDialogOpen(false);
                            }}
                        >
                            Close
                        </ButtonComponent>
                    </div>
                </div>
            </DialogComponent>
        </div>
    )
}
export default TestOrderResultTableComponent;
